module.exports = __webpack_public_path__ + "img/fushimi-HP-bfore&after.495b6946.png";